<app-rfi-answer-completeness [completeness]="completeness()" />
<div class="flex flex-col">
  @for (reference of answers(); track reference.scaNumber) {
    <div
      class="border-surface-500 flex items-center justify-between gap-4 border-0 border-t py-2 text-sm"
    >
      <span>{{ reference.label }}</span>
      <span class="font-semibold whitespace-nowrap">
        {{
          reference.fulfillmentKey ?? 'project.steps.providerResults.individual.notSpecified'
            | transloco
        }}
      </span>
    </div>
  }
</div>
<span class="text-muted-color text-sm">
  {{ 'project.steps.providerResults.individual.referencesHint' | transloco }}
</span>
